// extracted by mini-css-extract-plugin
export default {"offlineModeInfo":"styles_offlineModeInfo__hVnkA","offlineBanner":"styles_offlineBanner__r+-FP","dashboardLink":"styles_dashboardLink__Gvvvo"};